module.exports = __webpack_public_path__ + "static/art3-7272f741b6eb7b57ff7caf8a143dcd88.png";